import React from "react";
import DealColumnsForm from "forms/DealColumnsForm";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import Translate from "utils/translate";

const { t } = new Translate("DealColumns");

const DealColumnsModal = ({ loading, onClose, onSubmit, userID }) => (
  <Modal onClose={onClose} width={300} isOpen>
    <ModalHeader onClose={onClose}>{t("title")}</ModalHeader>
    <ModalBody>
      <DealColumnsForm loading={loading} onSubmit={onSubmit} userID={userID} />
    </ModalBody>
  </Modal>
);

DealColumnsModal.propTypes = {
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  userID: PropTypes.number,
};

export default DealColumnsModal;
